/* Zest snap gallery — native CSS scroll-snap replacement for the Slick galleries.
 * Added 2026-08-12.
 *
 * Why: Slick simulates dragging in JS. It has no momentum, and it swallows the
 * touchmove to decide swipe-vs-scroll, which means a downward drag that starts on
 * the image can eat the page scroll. Handing the gesture back to the browser's own
 * scroller fixes that, and gets momentum and rubber-banding for free.
 *
 * Safety: this only ever ADDS classes/elements. If it throws or never runs, the
 * markup is untouched and the original CSS still applies. Every gallery is also
 * skipped if Slick already initialised it, so this can never double-bind.
 *
 * Revert: delete this file + the <script>/<link> in layout/theme.liquid, and
 * restore the slick inits in assets/custom_s.js and the LP sections.
 */
(function () {
  'use strict';

  var GALLERIES = [
    {
      name: 'pdp',
      rail: '.template-product-custom-new-product .product-image-carousel',
      item: '.image-item',
      thumbs: '.template-product-custom-new-product .product-image-thumbnails',
      thumb: '.thumbnail-item',
      arrows: true,
      dots: false
    },
    {
      name: 'promo-lp',
      rail: '.promo-gallery-main',
      item: '.promo-gallery-slide',
      thumbs: '.promo-gallery-thumbs',
      thumb: '.promo-thumb-item',
      arrows: true,
      dots: false
    },
    /* NOTE: the gruns-style LPs (preset-g, parents, elite-hydration-bundle, v7) are
       deliberately NOT in this list. Their .gallery-main is not a scroller at all —
       the slides are position:absolute with opacity:0 and crossfade on tap, so
       turning it into a snap rail leaves 8 of 9 slides invisible. Converting it
       needs template-side CSS + its own arrow/thumb wiring, tracked separately. */
  ];

  function itemWidth(rail) {
    var first = rail.querySelector('.zsg-item');
    if (!first) return rail.clientWidth || 1;
    var w = first.getBoundingClientRect().width;
    return w > 0 ? w : (rail.clientWidth || 1);
  }

  function indexOf(rail) {
    var items = rail.querySelectorAll('.zsg-item');
    if (!items.length) return 0;
    // nearest item to the rail's centre — robust for peeking layouts
    var mid = rail.scrollLeft + rail.clientWidth / 2;
    var best = 0, bestD = Infinity;
    for (var i = 0; i < items.length; i++) {
      var c = items[i].offsetLeft - rail.offsetLeft + items[i].offsetWidth / 2;
      var d = Math.abs(c - mid);
      if (d < bestD) { bestD = d; best = i; }
    }
    return best;
  }

  function goTo(rail, i) {
    var items = rail.querySelectorAll('.zsg-item');
    if (!items.length) return;
    i = Math.max(0, Math.min(items.length - 1, i));
    var target = items[i].offsetLeft - rail.offsetLeft
               - (rail.clientWidth - items[i].offsetWidth) / 2;
    rail.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
  }

  function build(cfg, rail) {
    if (rail.__zsg) return;
    // Never fight Slick — if it already owns this node, leave it alone.
    if (rail.classList.contains('slick-initialized')) return;
    var items = rail.querySelectorAll(':scope > ' + cfg.item);
    if (items.length < 2) return;
    rail.__zsg = true;

    for (var i = 0; i < items.length; i++) items[i].classList.add('zsg-item');
    rail.classList.add('zsg-on');
    rail.setAttribute('tabindex', '0');
    rail.setAttribute('role', 'region');
    rail.setAttribute('aria-label', 'Product image gallery');

    /* ---- thumbnails ---- */
    var thumbEls = [];
    if (cfg.thumbs) {
      var scope = rail.closest('.height-wrapper, .gallery, .promo-gallery-wrapper, section, body') || document;
      var thumbs = scope.querySelector(cfg.thumbs) || document.querySelector(cfg.thumbs);
      if (thumbs && !thumbs.classList.contains('slick-initialized')) {
        thumbs.classList.add('zsg-thumbs-on');
        thumbEls = Array.prototype.slice.call(thumbs.querySelectorAll(':scope > ' + cfg.thumb));
        thumbEls.forEach(function (t, n) {
          t.classList.add('zsg-thumb');
          t.setAttribute('aria-current', n === 0 ? 'true' : 'false');
          t.addEventListener('click', function (e) { e.preventDefault(); goTo(rail, n); });
        });
        rail.__zsgThumbs = thumbs;
      }
    }

    /* ---- arrows ----
       The rail gets its own wrapper so the arrows centre on the images and not on
       whatever else shares the parent (on the PDP the parent also holds the
       thumbnail strip). All the theme's CSS targets the rail by descendant
       selector, so an extra wrapper is invisible to it. */
    var prev, next;
    if (cfg.arrows) {
      var parent = rail.parentNode;
      if (parent) {
        var wrap = document.createElement('div');
        wrap.className = 'zsg-wrap';
        parent.insertBefore(wrap, rail);
        wrap.appendChild(rail);
        parent = wrap;
        prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'zsg-arrow zsg-prev';
        prev.setAttribute('aria-label', 'Previous image');
        prev.innerHTML = '&#8249;';
        next = prev.cloneNode(true);
        next.className = 'zsg-arrow zsg-next';
        next.setAttribute('aria-label', 'Next image');
        next.innerHTML = '&#8250;';
        prev.addEventListener('click', function () { goTo(rail, indexOf(rail) - 1); });
        next.addEventListener('click', function () { goTo(rail, indexOf(rail) + 1); });
        parent.appendChild(prev);
        parent.appendChild(next);
      }
    }

    /* ---- dots ---- */
    var dotEls = [];
    if (cfg.dots && rail.parentNode) {
      var dots = document.createElement('div');
      dots.className = 'zsg-dots';
      for (var d = 0; d < items.length; d++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to image ' + (d + 1));
        b.setAttribute('aria-current', d === 0 ? 'true' : 'false');
        (function (n) { b.addEventListener('click', function () { goTo(rail, n); }); })(d);
        dots.appendChild(b);
        dotEls.push(b);
      }
      rail.parentNode.insertBefore(dots, rail.nextSibling);
    }

    /* ---- keep everything in sync with wherever the user scrolled to ---- */
    function sync() {
      var i = indexOf(rail);
      thumbEls.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dotEls.forEach(function (b, n) { b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= items.length - 1;
      // drag the active thumbnail into view without moving the page
      var active = thumbEls[i];
      if (active && rail.__zsgThumbs) {
        var tr = rail.__zsgThumbs, a = active.getBoundingClientRect(), r = tr.getBoundingClientRect();
        if (a.left < r.left || a.right > r.right) {
          tr.scrollTo({ left: active.offsetLeft - tr.offsetLeft - (tr.clientWidth - active.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    }
    var t = null;
    rail.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(sync, 60);
    }, { passive: true });
    window.addEventListener('resize', function () { if (t) clearTimeout(t); t = setTimeout(sync, 120); });

    /* ---- keyboard ---- */
    rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(rail, indexOf(rail) + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(rail, indexOf(rail) - 1); }
    });

    sync();

    /* ---- public handle, used by the PDP variant sync ---- */
    rail.zsgGoTo = function (i) { goTo(rail, i); };
    rail.zsgGoToMediaId = function (id) {
      var items = rail.querySelectorAll('.zsg-item');
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].getAttribute('data-media-id')) === String(id)) { goTo(rail, i); return true; }
      }
      return false;
    };
  }

  function init() {
    GALLERIES.forEach(function (cfg) {
      var rails = document.querySelectorAll(cfg.rail);
      for (var i = 0; i < rails.length; i++) {
        try { build(cfg, rails[i]); } catch (e) {
          if (window.console && console.warn) console.warn('[zsg] ' + cfg.name + ' skipped', e);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Shopify section re-renders (variant swaps, theme editor) re-run init safely.
  document.addEventListener('shopify:section:load', init);
  window.ZestSnapGallery = { init: init };
})();
